import React from 'react';
import { Col, Form, Input } from 'antd';
import isEmail from 'validator/lib/isEmail';

type Props = {
    required?: boolean;
};

export function AdminShopmanagerFields({ required }: Props) {
    const form = Form.useFormInstance();

    return (
        <>
            <Col xs={24} md={12} lg={6}>
                <Form.Item
                    label="ID lojista"
                    name="shopManagerId"
                    rules={[
                        {
                            validator: (_, value) => {
                                if (
                                    required &&
                                    !Number(value) &&
                                    !form.getFieldValue('email')
                                ) {
                                    return Promise.reject(
                                        new Error(
                                            'Por favor, informe o id do lojista',
                                        ),
                                    );
                                }
                                return Promise.resolve();
                            },
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={6}>
                <Form.Item
                    label="E-mail lojista"
                    name="email"
                    rules={[
                        {
                            validator: (_, value) => {
                                const hasId =
                                    !!form.getFieldValue('shopManagerId');
                                if (required && !hasId && !value) {
                                    return Promise.reject(
                                        new Error(
                                            'Por favor, informe o email do lojista',
                                        ),
                                    );
                                }
                                if (value && !isEmail(value)) {
                                    return Promise.reject(
                                        new Error(
                                            'Por favor, informe um email válido',
                                        ),
                                    );
                                }
                                return Promise.resolve();
                            },
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
            </Col>
        </>
    );
}
